export class setCurrentTime {
  constructor () {
    this.el = document.querySelector('[data-current-time]')
    this.date = new Date()

    this.start()

  }

  clock() {
    this.date = new Date()
    this.el.innerHTML = this.date.toLocaleTimeString() 
    
    // console.log(this.el, 'clock: update the count')
  }

  start() {
    this.el = document.querySelector('[data-current-time]')

    if (!this.el) return

    this.el.innerHTML = this.date.toLocaleTimeString() 
    this.time = setInterval(this.clock.bind(this), 1000)

    // console.log(this.el, 'clock: start the count')
  }

  clear() {
   clearInterval(this.time)
  }

}